import { render, staticRenderFns } from "./AclEditionCheckboxes.vue?vue&type=template&id=03870a7c&"
import script from "./AclEditionCheckboxes.vue?vue&type=script&lang=js&"
export * from "./AclEditionCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports